module.exports = __webpack_public_path__ + "static/image-04-b@2x-ec035cb3fd235e0952ed63197f9a6abb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/case-studies/designmuseum/image-04-b@2x.jpg
// module id = 370
// module chunks = 3627797113349 20562973939449 33019919093843